module.exports = __webpack_public_path__ + "static/img/viewing_duration.d3ca2d28.png";